export default __webpack_public_path__ + "static/media/bad.9b71c9de.svg";